package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.objects

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontLineHeight
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.pages.components.CircleIcon

@Composable
fun RestaurantProjectObjectHeader(
    isExpanded: Boolean,
    title: String,
    onItemClick:()->Unit,
){

    Row(
        modifier = Modifier
            .cursor(Cursor.Pointer)
            .padding(leftRight = Dimen.largePadding)
            .height(Dimen.restaurantOptionHeight)
            .fillMaxWidth()
            .onClick {
                onItemClick()
            }
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
    )
    {
        SpanText(
            text = title,
            modifier = Modifier
                .fontWeight(FontWeight.Normal)
                .lineHeight(FontLineHeight.lineLarge)
                .color(Theme.TextPrimary.rgb)
                .fontFamily(FontFamily.Jakarta)
        )

        Spacer()

        CircleIcon(
            modifier = Modifier ,
            borderColor = Theme.Transparent.rgb,
            img =if (isExpanded)
                    Res.PathIcon.arrowTop2
                else Res.PathIcon.arrowBottom2,
            size = Dimen.mediumIconSize,
            onIconClick = {}
        )






    }



}